/**
 * Exportar a `.gemba.json` desde cualquier lugar (inicio, barra del proyecto, historial). Si el
 * espacio de trabajo tiene datos reales, pide confirmación y el archivo lo declara (doc. 02 §8).
 */

import type { Evento } from '../../nucleo/dominio/ejecucion';
import { registroCsv, registroJsonLines } from '../../nucleo/registro/exportar';
import { exportarDocumento, nombreDeArchivo } from '../../persistencia/archivo';
import { ahoraIso } from '../formato';
import { M } from '../mensajes/es-PE';
import { avisar } from '../ui/avisos';
import { confirmar } from '../ui/Confirmaciones';
import { descargarTexto, VERSION_APP } from './descargas';
import { repositorio } from './repositorio';

export async function exportarArchivo(
  documento: unknown,
  nombre: string,
  espacioDeTrabajoId: string,
): Promise<boolean> {
  const espacio = await repositorio().obtenerEspacioDeTrabajo(espacioDeTrabajoId);
  const datosReales = espacio?.contieneDatosReales ?? false;
  if (
    datosReales &&
    !(await confirmar({
      titulo: M.organizacion.exportarTitulo,
      texto: M.organizacion.exportarTexto,
      confirmar: M.organizacion.exportarConfirmar,
    }))
  )
    return false;
  const archivo = nombreDeArchivo({ nombre });
  descargarTexto(archivo, exportarDocumento(documento, VERSION_APP, ahoraIso(), datosReales));
  avisar(M.proyecto.exportado(archivo), 'exito');
  return true;
}

/**
 * Registro de eventos de la réplica que se ve (paso 1.6, avance 4; doc. 04 §13): JSON Lines o CSV.
 * Con datos reales, pide la misma confirmación que exportar el proyecto (ADR 0020).
 */
export async function exportarRegistro(
  eventos: readonly Evento[],
  formato: 'jsonl' | 'csv',
  nombreEspacio: string,
  espacioDeTrabajoId: string,
): Promise<boolean> {
  const espacio = await repositorio().obtenerEspacioDeTrabajo(espacioDeTrabajoId);
  if (
    espacio?.contieneDatosReales &&
    !(await confirmar({
      titulo: M.organizacion.exportarTitulo,
      texto: M.organizacion.exportarTexto,
      confirmar: M.organizacion.exportarConfirmar,
    }))
  )
    return false;
  const base = nombreDeArchivo({ nombre: `registro ${nombreEspacio}` }).replace(
    /\.gemba\.json$/,
    '',
  );
  const archivo = `${base}.${formato}`;
  if (formato === 'jsonl')
    descargarTexto(archivo, registroJsonLines(eventos), 'application/x-ndjson');
  else descargarTexto(archivo, registroCsv(eventos), 'text/csv;charset=utf-8');
  avisar(M.simulacion.registroExportado(archivo), 'exito');
  return true;
}
